/*eslint-disable*/
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

// components
import { Button } from '@mui/material'
import { BRAND_OPTIONS } from './login.constants'
import Logo from '../../../../assets/jj_red_logo.svg'
import SelectField from "../../../../components/selectField/LoginSelectField";

// utils
import { applicationAuthClient, janssenApplicationAuthClient } from '../../../../okta/oktaClient'
import { getEnvLabel } from '../../../../helpers/general'
import { useIsMobileView } from '../../../../utils/isMobileView'

// styles
import styles from './login.module.scss'
import { fontSize } from '@mui/system';

const submitStyle = {
  width: '120px',
  fontSize: '11px',
  marginTop: '20px',
  backgroundColor: '#eb1700',
  textTransform: 'none !important',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: 'rgba(102, 90, 71, 0.15) !important',
    color:'#616161',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },
}

const oktaAuth = applicationAuthClient

const janssenOktaAuth = janssenApplicationAuthClient

function Login() {
  const { t } = useTranslation()
  const [brand, setBrand] = useState('')
  const isMobile = useIsMobileView()

  const handleBrandChange = (event) => {
    event?.stopPropagation();
    const { value } = event?.target || {};
    setBrand(value);
    localStorage.setItem('tenant', value)
  }

  const handleLoginClick = () => {
    if(brand === 'GlobalInnovMed') {
      janssenOktaAuth.signInWithRedirect()
    } else {
      oktaAuth.signInWithRedirect()
    }
  }

  return (
    <div className={styles.signIn}>
      <div>
        <img height="29px" width="318px" src={Logo} alt="Logo" className={styles.brandLogo} />
        <div className={styles.welcomeContainer}>
          <hr style={{ position: 'absolute', left: '-210px', width: 'calc(100vw + 210px)', marginLeft: '0', top: '0' }} />
          <div style={{ paddingTop: '18px', paddingRight: '20px' }}>
            <h1 className={styles.welcomeMessage}>{t('welcome-message')}</h1>
          </div>

          <p
            className={styles.welcomeBody}
          >
            {t('welcome-body')}
          </p>
          <div>
            <SelectField
              options={BRAND_OPTIONS}
              label={t('sign-in-blurb')}
              id="brand"
              value={brand}
              error=""
              onChange={handleBrandChange}
              styles={{ width: "300px" }}
            />

            <Button
              className="primary-btn"
              variant="contained"
              type="button"
              disableElevation={true}
              onClick={handleLoginClick}
              sx={{ ...submitStyle }}
              disabled={!brand}
            >
             {t('sign-in')}
            </Button>

          </div>
        </div>
      </div>
    </div>
  )
}
export default Login